<template>
  <div class="container">
    <h2>Carrito</h2>
    <template v-if="cart && cart.length > 0">
        <CartProduct :product="getProduct(product)" v-for="(product, index) of cart" :key="index" @addToCart="addToCart" @removeFromCart="removeFromCart" />
        <div class="d-grid gap-2">
            <a class="btn btn-primary" :href="link()" target="_blank">Comenzar compra por un total de ${{getTotal()}}</a>
        </div>
    </template>
    <template v-else>
        <h5>Agregue productos al carrito primero</h5>
    </template>
  </div>
</template>

<script>
import CartProduct from '../components/CartProduct';

export default {
    name: 'Cart',
    props:['catalog', 'cart', 'contact'],
    components:{
        CartProduct
    },
    methods:{
        getProduct(prod){
            return {...prod, ...this.catalog.find(p => p.id == prod.id)}
        },
        link(number = this.contact.phone){
            let message = "Hola Stylo Lanus, me gustaria comenzar el proceso de compra para los siguientes articulos:%0a"
            message += this.cart.map(p => {
                let prod = this.getProduct(p);
                return `- ${p.quantity} "${prod.prices[p.pack].quantity} ${prod.name}" por $${prod.prices[p.pack].price * p.quantity}`
            }).join("%0a")
            return `https://api.whatsapp.com/send/?phone=${number}&text=${message}`
        },
        addToCart(id, pack, quantity){
            this.$emit('addToCart', id, pack, quantity)
        },
        removeFromCart(id, pack){
            this.$emit('removeFromCart', id, pack)
        },
        getTotal(){
            var total = 0;
            this.cart.forEach(p => {
                total += this.catalog.find(aux=>aux.id == p.id).prices[p.pack].price * p.quantity
            })
            return total
        }
    }
}
</script>

<style>

</style>